<template>
    <div class="mt-8">
        <form @submit.prevent="onSubmit">
            <FormField v-slot="{ componentField }" name="name">
                <FormItem v-auto-animate>
                    <Label
                        for="name"
                        class="gap-2 flex items-center justify-between"
                    >
                        <div>
                            {{
                                $t(
                                    "event_types.availability.calendar_managed_availability_events_title",
                                )
                            }}

                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger
                                        ><CircleHelp :size="16"
                                    /></TooltipTrigger>
                                    <TooltipContent>
                                        <p class="px-1 py-0.5 max-w-[200px]">
                                            {{
                                                $t(
                                                    "event_types.availability.calendar_managed_title_tooltip",
                                                )
                                            }}
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>

                        <button
                            class="font-medium text-z-primary-600"
                            @click.prevent="copy(name)"
                        >
                            <span v-if="copied"> {{ $t("copied") }}</span>
                            <span v-else>
                                {{
                                    $t(
                                        "event_types.availability.copy_title_name",
                                    )
                                }}</span
                            >
                        </button>
                    </Label>
                    <FormControl>
                        <Input
                            type="text"
                            placeholder="moje dostupnost"
                            v-bind="componentField"
                        />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            </FormField>
            <div v-auto-animate class="mt-4 flex justify-end">
                <Button
                    class="flex"
                    type="submit"
                    v-if="values.name !== savedName"
                >
                    {{ $t("save") }}
                </Button>
            </div>
        </form>

        <SetMeetingDuration class="mt-2" :event-type="eventType" />
    </div>
</template>

<script setup lang="ts">
import type { EventType } from "../../types/EventType";
import type { EventTypeUser } from "../../types/EventTypeUser";

import SetMeetingDuration from "../BookingPage/components/SetMeetingDuration.vue";
import { ref } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { router } from "@inertiajs/vue3";
import {
    FormControl,
    FormField,
    FormItem,
    FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import route from "ziggy-js";
import { vAutoAnimate } from "@formkit/auto-animate";
import { CircleHelp } from "lucide-vue-next";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { useClipboard } from "@vueuse/core";

const props = defineProps<{
    eventType: EventType;
    eventTypeUser: EventTypeUser;
}>();

const { copied, copy } = useClipboard();

const name = ref(props.eventTypeUser.calendar_integration_availability_name);
const savedName = ref(
    props.eventTypeUser.calendar_integration_availability_name,
);

const formSchema = toTypedSchema(
    z.object({
        name: z.string().min(1).max(50).default(name.value),
    }),
);

const { handleSubmit, values } = useForm({
    validationSchema: formSchema,
});

function updateName(newName: string) {
    router.put(
        route("app.event-types.calendar-integration-availability-name", {
            eventType: props.eventType.id,
        }),
        {
            name: newName,
        },
    );

    savedName.value = newName;
}
const onSubmit = handleSubmit((values) => {
    updateName(values.name);
});
</script>
